// -----------------------------------------------------------------------------
// Profil
// -----------------------------------------------------------------------------

let sectionsCount = 100;

const init = () => {
  initEventListeners();
};

/**
 * Event-Listeners initialisieren
 */
const initEventListeners = () => {
  // Formular für weiteren Ansprechpartner zeigen
  $(document).on('click', '.js-add-contact', function () {
    addContact();
  });

  // Alle Antworten selektieren für i2 Fragebogen
  if ($('.js-i2-i-filter, .js-i2-i-profile, .js-eqf-i-profile').find('.js-select-all').length) {
    selectAllOptions();
  }
};

/**
 * Formular für weiteren Ansprechpartner zeigen
 */
const addContact = () => {
  const template = $('#ASPContainer .template').clone().removeClass('template').removeClass('d-none');
  template.prop('id', 'ansprechPartner' + sectionsCount);

  // Elemente des neuen Formular-Bereiches anpassen
  template.find(':input').each(function () {
    // `ID` eindeutig benennen
    const oldId = this.id;
    const newId = oldId + sectionsCount;
    $(this).prop('id', newId);

    // Label anpassen
    const label = template.find('label[for="' + oldId + '"]');
    label.attr('for', newId);

    // `name` eindeutig benennen
    const name = $(this).attr('name');
    if (name) {
      $(this).attr('name', name.replace('###COUNTER###', 'new' + sectionsCount));
    }

    //	if ( this.id == 'ASP_Email') $(this).attr('required', 'required');
    if ($(this).hasClass('required')) {
      $(this).attr('required', 'required');
    }
  });
  template.appendTo('#ASPContainer').show();
  sectionsCount += 1;
};

/**
 * Selektiert alle Checkboxes für eine Frage
 */
const selectAllOptions = () => {
  $('.js-select-all').click(function () {
    const checkwhat  = $(this).data('checkwhat');
    $('input:checkbox.' + checkwhat).not(this).prop('checked', this.checked);
  });
};

export {
  init
};
